<template functional>
  <div
    v-if="typeof(props.task) !== 'undefined' && props.task"
    @click="$options.openTaskModal(props.view, props.task._id, parent)"
    :style="{'filter': props.task.status === 'done' || props.task.status === 'canceled' ? 'opacity(60%)' : ''}"
    class="unselectable taskViewContainer row p-1">
    <div
      :class="[props.is_inbox ? 'col-9 pr-0' : 'col-12']"
      style="white-space: normal;">
      <h3 class="mb-0">
        <span class="taskTitle">
          {{props.task.status==='done' || props.task.status==='canceled' ? $options.truncText(props.task.name) : props.task.name}}
        </span>
      </h3>
      <span v-if="props.task.status === 'done' && props.view.startsWith('calendar')" class="badge badge-primary mt-1 mb-1 mr-1">
          <i class="fe fe-check-circle mr-1"></i> {{ parent.$t("elements.task_view.done") }}
      </span>
      <span v-if="props.task.status === 'canceled' && props.view.startsWith('calendar')" class="badge badge-warning mt-1 mr-1">
        <i style="vertical-align: top; line-height: 12px" class="fe fe-x"></i>
        <span style="vertical-align: top; line-height: 10px; font-size: 11px">
          {{ parent.$t("elements.task_view.canceled") }}
        </span>
      </span>
      <span v-if="props.task.priority === 'low'" class="badge badge-soft-light mt-1 mb-1 mr-1" >
        <i class="fe fe-star mr-1"></i>{{ parent.$t("elements.task_view.low") }}
      </span>
      <span v-if="props.task.priority === 'high'" class="badge badge-soft-warning mt-1 mb-1 mr-1">
        <i class="fe fe-star mr-1"></i>{{ parent.$t("elements.task_view.high") }}
      </span>
      <span v-if="props.task.priority === 'urgent'" class="badge badge-soft-danger mt-1 mb-1 mr-1">
        <i class="fe fe-star mr-1"></i>{{ parent.$t("elements.task_view.urgent") }}
      </span>
      <span
        v-if="props.task.deadline_date"
        :class="{'badge-danger': $options.calculateDeadlineBadge(props.task).type === 'failed', 'badge-soft-danger': $options.calculateDeadlineBadge(props.task).type === 'danger', 'badge-soft-dark': $options.calculateDeadlineBadge(props.task).type === 'normal'}"
        class="badge mt-1 mb-1 mr-1">
        {{ $options.calculateDeadlineBadge(props.task).text }}
      </span>
      <span v-if="props.projects.length && props.task.project_id" class="badge badge-pill bg-white mt-1 mb-1 mr-1 por">
        {{ props.projects.find(project => project._id === props.task.project_id)['name'] }}
        <template v-if="!!props.task.section_id && !!props.sections.find(section => section._id === props.task.section_id)">
          | <i class="fe fe-folder"></i> {{ props.sections.find(section => section._id === props.task.section_id).name }}
        </template>
      </span>
      <span
          v-for="epic_link_id in props.task.epic_links"
          :key="epic_link_id"
          class="badge badge-soft-secondary mt-1 mb-1 mr-1"
      >
        <span v-if="$options.getEpicLinkById(props.epicLinks, epic_link_id)">
          {{$options.getEpicLinkById(props.epicLinks, epic_link_id).emoji}} {{$options.getEpicLinkById(props.epicLinks, epic_link_id).name}}
        </span>
      </span>
      <span
        v-if="props.task.sub_tasks_count"
        class="badge badge-secondary mt-1 mb-1 mr-1">
        <svg style="margin-right: 1px" width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.71431 1.71428V5.14285C1.71431 5.77403 2.22598 6.28571 2.85717 6.28571H6.28574" stroke="white" stroke-width="0.76"/>
          <circle cx="1.71429" cy="1.71429" r="1.33429" fill="#96ABC8" stroke="white" stroke-width="0.76"/>
          <circle cx="6.28573" cy="6.28573" r="1.33429" fill="#96ABC8" stroke="white" stroke-width="0.76"/>
        </svg>
        {{ props.task.done_sub_tasks_count }} | {{ props.task.sub_tasks_count }}
      </span>
    </div>
    <div v-if="props.is_inbox" class="col-3">
      <img
        v-if="$options.getPerson(props.members ,props.task.assignee).picture_url"
        :src="$options.getPerson(props.members ,props.task.assignee).picture_url"
        style="width: 26px; height: 26px"
        alt="..."
        class="avatar-img rounded-circle shadow mr-2 float-left">
      <span
        v-else
        class="avatar-title rounded-circle shadow mr-2 float-left"
        style="width: 26px; height: 26px">
          {{($options.getPerson(props.members ,props.task.assignee).first_name || '').slice(0, 1)+($options.getPerson(props.members ,props.task.assignee).last_name || '').slice(0, 1)}}
      </span>
    </div>
    <span
      id="hideOnHover"
      class="float-right">
        <code>
          <span class="badge badge-soft-white text-blue font-weight-bold float-right">
            <i v-if="!props.task.duration" class="fe font-weight-bold fe-clock"></i>
            {{$options.stringifyDurationMixin.methods.stringifyDuration(props.task.duration)}}
          </span>
        </code>

        <br v-if="props.view.startsWith('calendar')">

        <code>
          <span class="badge badge-soft-white text-primary font-weight-bold float-right">
            <i v-if="!props.task.duration_actual" class="fe font-weight-bold fe-clock"></i>
            {{$options.stringifyDurationMixin.methods.stringifyDuration(props.task.duration_actual)}}
          </span>
        </code>
      </span>
    <span
      id="showOnHover"
      class="float-right">
          <button @click.stop="$options.setStatus('wip', props.task, parent)" v-if="props.task.status === 'done'" class="btn btn-sm rounded-circle btn-primary ">
            <i class="fe font-weight-bold fe-check-circle"></i>
          </button>
          <button @click.stop="$options.setStatus('done', props.task, parent)" v-if="props.task.status === 'new' || props.task.status === 'wip'" class="btn btn-light btn-sm">
            <i class="fe font-weight-bold text-secondary fe-check-circle "></i>
          </button>
          <button @click.stop="$options.setStatus('deleted', props.task, parent)" v-if="props.task.status === 'canceled'" class="btn btn-sm btn-light ">
            <i class="fe font-weight-bold text-secondary fe-archive"></i>
          </button>
      </span>
  </div>
</template>

<script>
  import { stringifyDurationMixin } from '@/mixins/stringifyDurationMixin';
  const moment = require('moment');
  export default {
    props: {
      task: Object,
      view: String,
      is_inbox: Boolean,
      epicLinks: Array,
      projects: Array,
      sections: Array,
      members: Array,
    },
    stringifyDurationMixin,
    truncText (text) {
      return (text.length > 45) ? text.substr(0, 45 - 1).trim() + '...' : text;
    },
    getPerson (members, personId) {
      return members.find(user => user._id === personId, 1) || {};
    },
    getEpicLinkById (epicLinks, epicLinkId) {
      return epicLinks.find(epicLink => epicLink._id === epicLinkId, 1) || {};
    },
    calculateDeadlineBadge: function (task) {
      const deadline = task.deadline_date;
      const now = moment();
      if (task.status !== 'wip') {
        return {
          text: moment(deadline).format('MMM DD'),
          type: 'normal',
        };
      }
      if (now.isSameOrBefore(deadline)) {
        if (moment(deadline).diff(now, 'days') < 7) {
          const type = moment(deadline).diff(now, 'days') <= 1 ? 'danger' : 'normal';
          return {
            text: moment(deadline).fromNow(true) + ' left',
            type,
          };
        } else {
          return {
            text: 'Until ' + moment(deadline).format('MMM DD'),
            type: 'normal',
          };
        }
      } else {
        return {
          text: 'Overdue',
          type: 'failed',
        };
      }
    },
    openTaskModal (view, taskId, parent) {
      if (view === 'day_plan' || ((view !== 'list' && view !== 'calendar_day_info') && (view.startsWith('calendar')))) {
        parent.$store.commit('setSelectedTask', taskId);
        parent.$store.commit('showModal', 'edit_task');
      }
    },
    setStatus (newStatus, task, parent) {
      task.status = newStatus;
      parent.$store.dispatch('updateTask', task);
    },
  };
</script>

<style scoped>
  .taskViewContainer {
    min-height: 35px;
    position: relative;
  }

  h3 {
    font-size: 0.87rem;
    transition-duration: 3s;
    font-weight: 400 !important;
    text-shadow: gainsboro 0px 0.5px;
  }
  .checkCircle {
    color: #96ABC8;
  }
  .taskTitle {
    display: inline-block;
    width: 90%;
    min-height: 19px;
    white-space: normal;
    font-style: normal;
    line-height: 1.5;
    vertical-align: 2px;
    text-shadow: 0 0.5px gainsboro;
    line-break: auto;
  }

  .badge {
    font-size: 10px;
  }

  .text {
    white-space: normal
  }

  .s {
    text-decoration: line-through;
  }

  .text-blue {
    color: #2c7be5;
  }

  #showOnHover {
    transition-duration: .5s;
    position: absolute;
    right: 15px;
    top: 0;
    opacity: 0;
  }
  #hideOnHover {
    transition-duration: .5s;
    position: absolute;
    right: 15px;
    top: 0;
    opacity: 1;
  }

  .taskViewContainer:hover #showOnHover{
    transition-duration: .3s;
    opacity: 1;
  }
  .taskViewContainer:hover #hideOnHover{
    transition-duration: .3s;
    opacity: 0;
  }
</style>
